import * as React from 'react';
import styled from '../../theme';
import ErrorMessage from './ErrorMessage';

interface IInputProps {
    id?: string
    placeholder: string
    maxLength: number
    inputValue: string
    hasError: boolean
    errorMessage: string
    type?: string
    checkInput(): void
    changeInputValue(input: string): void
    preventSpecificKeys?(e: React.KeyboardEvent): any
}
interface IInputState {
    hasFocus: boolean
    hasContent: boolean
}

class InputComponent extends React.Component<IInputProps, IInputState> {
    constructor(props: IInputProps) {
        super(props);
        this.state = {
            hasFocus: false,
            hasContent: false,
        }
        this.handleFocus = this.handleFocus.bind(this)
        this.checkLength = this.checkLength.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.preventKeys = this.preventKeys.bind(this)
        this.changeValue = this.changeValue.bind(this)
    }

    public componentDidUpdate(prevProps: any) {
        if (this.props.inputValue !== prevProps.inputValue) {
            this.checkLength()
        }
    }

    public handleFocus(e: React.FormEvent<HTMLInputElement>): void {
        this.setState({
            hasFocus: true
        })
        this.checkLength()
    }

    public checkLength(): void {
        this.setState({
            hasContent: this.props.inputValue.length > 0 ? true : false
        })
    }

    public changeValue(e: React.FormEvent<HTMLInputElement>): void {
        this.props.changeInputValue(e.currentTarget.value)
    }

    public handleBlur(e: React.FormEvent<HTMLInputElement>): void {
        this.checkLength()
        this.setState({
            hasFocus: false
        })
        this.props.checkInput()
    }

    public preventKeys(e: React.KeyboardEvent): any {
        if (e.key === 'Enter') {
            e.preventDefault();
            return false
        }
        if (this.props.preventSpecificKeys) {
            this.props.preventSpecificKeys(e)
        }
    }


    public render() {
        return (
            <InputWrapper>
                <Wrapper>
                    <Input
                        id={this.props.id || 'input'}
                        onInput={this.changeValue}
                        type={this.props.type ? this.props.type : 'text'}
                        defaultValue={this.props.inputValue}
                        className={[(this.state.hasContent ? 'hasContent' : ''),
                        (this.state.hasFocus ? 'focused' : ''),
                        (this.props.hasError ? 'error' : '')].join(' ')}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        maxLength={this.props.maxLength}
                        onKeyPress={this.preventKeys}
                        autoComplete="off" />
                    <Label htmlFor="input">{this.props.placeholder}</Label>
                </Wrapper>
                <ErrorMessage content={this.props.errorMessage} className={this.props.hasError ? 'error' : ''} />
            </InputWrapper>
        )
    }
}

export default InputComponent;

const Input = styled.input`
    width: 100%;
    height: 100%;
    border: 1px solid #CCC;
    display: block;
    font-size: 0.9em;
    font-weight: 400;
    border-radius: 5px;
    background: #fff;
    box-sizing: border-box;
    padding-left: 20px;
    -webkit-appearance: none;
    border: none;
            
    &.focused {
        outline: none;
        box-shadow: 0 0 2px 2px ${(props: any) => props.theme.colors.backgroundHighlight};
    }

    &.focused + label {
        color: ${(props: any) => props.theme.colors.backgroundHighlight}
    }
            
    &.hasContent {
        outline: none;
        padding-top: 20px;
    }

    &.hasContent + label {
        font-size: 0.7em;
        top: 10px;
    }
        
    &.error {
        outline: none;
        box-shadow: 0 0 2px 2px red;
    }
        
    &.error + label {
        color: red;
    }
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &[type="number"] {
        -moz-appearance: textfield;
    }
`

const Label = styled.label`
    position: absolute;
    color: ${(props: any) => props.theme.colors.bodyLight}; 
    font-weight: 400;
    font-size: 0.9em;
    top: 20px;
    left: 20px;
    pointer-events: none;

`
const Wrapper = styled.div`
    position: relative;
    height: 55px;
    width: 100%;
    flex-direction: column; 
    flex-wrap: nowrap;
`
const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 10px 0;
    flex-direction: column; 
    flex-wrap: nowrap;
`



// WEBPACK FOOTER //
// ./src/components/Inputs/InputComponent.tsx